export class AddressDetailsModel {
  recordId: number = 0;
  clientId: number = 0;
  formId: string = "";
  pkTableId: string = "";
  addressLine1: string = "";
  addressLine2: string = "";
  city: string = "";
  country: string = "";
  state: string = "";
  pin: string = "";
  latitude: number = 0.00;
  longitude: number = 0.00;
  isActive: boolean = true;
  isDefault: boolean = true;
  isBilling: boolean = false;
  isDelivery: boolean = false;
  createdDate: Date = new Date();
  createdBy: string = "";
  lastModifiedDate: Date = new Date();
  lastModifiedBy: string = "";
  contactPersonName: string = "";
  addressTitle: string = "";
  contactNumber: string = "";
  addressType: string = "";
}

export class AddressConfigurationModel {
  formId: string = "";
  pkTableId: string = "";
  formTitle: string = "Customer Address";
  addFormName: string = "Customer Address";
  editFormName: string = "Customer Address";
  listReportFormName: string = "Saved Address";

  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  allowAddMultipleAddress: boolean = true;
  saveAddressFromParent: boolean = false;
  displayListCardView: boolean = false;

  googleMapAddressSearch: boolean = true;
  requiredFields: RequiredAddressFeilds = new RequiredAddressFeilds();
  allowedFields: AllowedAddressFeilds = new AllowedAddressFeilds();

  selectAddressSection: boolean = false;
  selectAddressSectionFor: string = ""; //for which component we are adding this, pass value from parent component.

  addressSectionSize: AddressSectionSize = new AddressSectionSize();
  fieldsTitle: FieldsTitle = new FieldsTitle();
}

export class AllowedAddressFeilds {
  addressLine1: boolean = true;
  addressLine2: boolean = true;
  country: boolean = true;
  state: boolean = true;
  city: boolean = true;
  pin: boolean = true;
  latLong: boolean = true;
  typeOptions: boolean = true;
  contactPersonName: boolean = true;
  contactNumber: boolean = true;
  saveThisAddressAs: boolean = true;
}

export class RequiredAddressFeilds {
  addressLine1: boolean = true;
  addressLine2: boolean = true;
  country: boolean = true;
  state: boolean = true;
  city: boolean = true;
  pin: boolean = true;
  latLong: boolean = true;
  typeOptions: boolean = true;
  contactPersonName: boolean = true;
  contactNumber: boolean = true;
  saveThisAddressAs: boolean = true;
}

export class RequiredFieldValidationModel {
  isContactPersonNameValid: boolean = true;
  contactPersonNameValidationMessage: string = "Contact Person Name is required";

  isAddressTitleValid: boolean = true;
  addressTitleValidationMessage: string = "'Save This Address' As is required";

  isAddressLine1Valid: boolean = true;
  AddressLine1ValidationMessage: string = "Address Line 1 is required";

  isAddressLine2Valid: boolean = true;
  AddressLine2ValidationMessage: string = "Address Line 2 is required";

  isCityValid: boolean = true;
  CityValidationMessage: string = "City is required";

  isCountryValid: boolean = true;
  CountryValidationMessage: string = "Country is required";

  isStateValid: boolean = true;
  StateValidationMessage: string = "State is required";

  isPinValid: boolean = true;
  PinValidationMessage: string = "PIN/ZIP is required";

  isLatitudeValid: boolean = true;
  LatitudeValidationMessage: string = "Latitude is required";

  isLongitudeValid: boolean = true;
  LongitudeValidationMessage: string = "Longitude is required";

  isFirstNameValid: boolean = true;
  firstNameValidationMessage: string = "First Name is required";

  isLastNameValid: boolean = true;
  lastNameValidationMessage: string = "Last Name is required";

  isContactNumberValid: boolean = true;
  contactNumberValidationMessage: string = "Contact Number is required";
}

export class AddressSectionSize {
  leftSide: string = "col-lg-6 col-md-6 col-sm-12 col-xs-12";
  rightSide: string = "col-lg-6 col-md-6 col-sm-12 col-xs-12";
}
//physical
export class FieldsTitle {
  isDelivery: string = "Delivery";
}
